import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../layout/Header.jsx';
import ListAdmins from '../../lists/ListAdmins.jsx';

const PageAdmins = () => {
  const { t } = useTranslation();

  return (
  <div>
    <Header>{t('Admins')}</Header>
    <ListAdmins />
  </div>
  );
};

export default PageAdmins;
